export const computeScaleAdaptedToFrame = (stage, media) => {

    if(stage.width > media.width && stage.height > media.height)
    {
        return 1
    }

    const ratioX = stage.width / media.width
    const ratioY = stage.height / media.height

    if(ratioX < ratioY)
    {
        return ratioX
    }

    return ratioY
}

export const download = (media) => {
    let link = document.createElement('a')
    link.setAttribute('href', media.location.original)
    link.setAttribute('download', '')
    link.setAttribute('target', '_blank')
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export function updateCursor(cursor)
{
    return (event) => {
        event.target.getStage().container().style.cursor = cursor
    }
}
